export default {"src":"/_next/static/media/save.c0d853c8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};